import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  Svg,
  Circle,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { color } from '../../../api/ColorsSector'
import { adress } from '../../../api/waterAdress'
import { formatWeight } from '../../../api/FormatWeight'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center',
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})
const PairComandGroupTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  const getname = (team) => {
    console.log(team)
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }
  Object.size = function (obj) {
    var size = 0,
      key
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++
    }
    return size
  }
  const hasZoneA = data[0] && data[0].athletesByZone?.['А']
  const hasZoneB = data[0] && data[0].athletesByZone?.['Б']
  const hasZoneC = data[0] && data[0].athletesByZone?.['В']

  // Считаем количество активных групп
  const activeGroups = [hasZoneA, hasZoneB, hasZoneC].filter(Boolean).length

  // Рассчитываем ширину для каждой группы
  const groupWidth = activeGroups > 0 ? `${45 / activeGroups}%` : '0%'

  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {adress(tournament.water_id)
                  ? adress(tournament.water_id)
                  : tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>
        <Text
          style={{
            fontSize: 12,
            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {tournament.status_cup == 'Турнир завершен' ? (
            <>ПРОТОКОЛ ТЕХНИЧЕСКИХ РЕЗУЛЬТАТОВ СОРЕВНОВАНИЙ</>
          ) : (
            <>ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПРОМЕЖУТОЧНЫХ РЕЗУЛЬТАТОВ СОРЕВНОВАНИЙ</>
          )}
          {/*  ИТОГОВЫЙ ПРОТОКОЛ */}
          {/*  */}
        </Text>
        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 13 }}>
          Ловля карпа - командные соревнования (мужчины, женщины), номер-код
          дисциплины 0920021811Л
        </Text>

        <View
          style={{
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 0.3,
            borderColor: '#000',
          }}
        >
          <View
            style={{
              height: '40px',
              flexDirection: 'row',
              alignItems: 'stretch',
            }}
          >
            {/* Фиксированные колонки */}
            <View style={[styles.tableColHeader, { width: '5%' }]}>
              <Text style={styles.tableText}>Место</Text>
            </View>

            <View style={[styles.tableColHeader, { width: '35%' }]}>
              <Text style={styles.tableText}>
                Команда, состав пар (Ф.И.О./разряд)
              </Text>
            </View>

            {/* Динамические колонки групп */}
            {(() => {
              // Определяем какие группы есть

              return (
                <>
                  {/* Группа А */}
                  {hasZoneA && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: '50%',
                          justifyContent: 'center',
                          borderBottomWidth: 0.3,
                          borderBottomColor: '#000',
                        }}
                      >
                        <Text style={styles.tableText}>Группа А</Text>
                      </View>
                      <View
                        style={{
                          flexDirection: 'row',
                          width: '100%',
                          height: '50%',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            {
                              width: '25%',
                              borderRightWidth: 0.3,
                              borderRightColor: '#000',
                            },
                          ]}
                        >
                          <Text style={styles.tableText}>сектор</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>вес</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>баллы</Text>
                        </View>
                      </View>
                    </View>
                  )}

                  {/* Группа Б */}
                  {hasZoneB && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: '50%',
                          justifyContent: 'center',
                          borderBottomWidth: 0.3,
                          borderBottomColor: '#000',
                        }}
                      >
                        <Text style={styles.tableText}>Группа Б</Text>
                      </View>
                      <View
                        style={{
                          flexDirection: 'row',
                          width: '100%',
                          height: '50%',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            {
                              width: '25%',
                              borderRightWidth: 0.3,
                              borderRightColor: '#000',
                            },
                          ]}
                        >
                          <Text style={styles.tableText}>сектор</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>вес</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>баллы</Text>
                        </View>
                      </View>
                    </View>
                  )}

                  {/* Группа В */}
                  {hasZoneC && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: '50%',
                          justifyContent: 'center',
                          borderBottomWidth: 0.3,
                          borderBottomColor: '#000',
                        }}
                      >
                        <Text style={styles.tableText}>Группа В</Text>
                      </View>
                      <View
                        style={{
                          flexDirection: 'row',
                          width: '100%',
                          height: '50%',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            {
                              width: '25%',
                              borderRightWidth: 0.3,
                              borderRightColor: '#000',
                            },
                          ]}
                        >
                          <Text style={styles.tableText}>сектор</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>вес</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>баллы</Text>
                        </View>
                      </View>
                    </View>
                  )}
                </>
              )
            })()}

            {/* Фиксированная колонка Итог */}
            <View
              style={[
                styles.tableColHeader,
                {
                  width: '15%',
                  padding: 0,
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                },
              ]}
            >
              <View
                style={{
                  height: '50%',
                  justifyContent: 'center',
                  borderBottomWidth: 0.3,
                  borderBottomColor: '#000',
                }}
              >
                <Text style={styles.tableText}>Итог</Text>
              </View>
              <View
                style={{ flexDirection: 'row', width: '100%', height: '50%' }}
              >
                <View style={[styles.tableColHeader, { width: '60%' }]}>
                  <Text style={styles.tableText}>Вес</Text>
                </View>
                <View style={[styles.tableColHeader, { width: '40%' }]}>
                  <Text style={styles.tableText}>Баллы</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        {data.map((item, index) => {
          if (Object.size(item.athletesByZone) == 1) return null

          const zoneА = item.athletesByZone?.['А'] || []
          const zoneБ = item.athletesByZone?.['Б'] || []
          const zoneВ = item.athletesByZone?.['В'] || []

          const teamА = item.teams?.[0] || {
            sector: '-',
            weight: 0,
            place: 0,
            sp: getname(item.athlete),
          }

          const teamБ = item.teams?.[1] || {
            sector: '-',
            weight: 0,
            place: 0,
            sp: getname(item.athlete),
          }
          const teamВ = item.teams?.[2] || {
            sector: '-',
            weight: 0,
            place: 0,
            sp: getname(item?.athlete || ''),
          }
          let noFishCaught = false
          // Проверка на команды без рыбы
          if (teamА.weight && teamБ.weight && teamВ.weight)
            noFishCaught =
              teamА.weight === 0 && teamБ.weight === 0 && teamВ.weight === 0
          else noFishCaught = teamА.weight === 0 && teamБ.weight === 0

          return (
            <>
              <View key={index} wrap={false}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'stretch',
                    backgroundColor:
                      item.bestResult < 4
                        ? '#fff'
                        : item.bestResult === 0
                          ? '#fff'
                          : '#fff',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '5%' }]}>
                    <Text style={styles.tableText}>
                      {noFishCaught ? data.length : item.finalPlace}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '35%' }]}>
                    <View style={{ padding: 2 }}>
                      <Text style={{ fontWeight: 'bold', fontSize: 8 }}>
                        {item.team || '-'}
                      </Text>
                      {zoneА[0]?.sp && (
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 2,
                          }}
                        >
                          <Svg width="10" height="10" viewBox="0 0 10 10">
                            <Circle cx="5" cy="5" r="4" fill={color('А')} />
                          </Svg>
                          <Text style={{ fontSize: 8, marginLeft: 5 }}>
                            {zoneА[0].sp}
                          </Text>
                        </View>
                      )}
                      {zoneБ[0]?.sp && (
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 2,
                          }}
                        >
                          <Svg width="10" height="10" viewBox="0 0 10 10">
                            <Circle cx="5" cy="5" r="4" fill={color('Б')} />
                          </Svg>
                          <Text style={{ fontSize: 8, marginLeft: 5 }}>
                            {zoneБ[0].sp}
                          </Text>
                        </View>
                      )}
                      {zoneВ[0]?.sp && (
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 2,
                          }}
                        >
                          <Svg width="10" height="10" viewBox="0 0 10 10">
                            <Circle cx="5" cy="5" r="4" fill={color('В')} />
                          </Svg>
                          <Text style={{ fontSize: 8, marginLeft: 5 }}>
                            {zoneВ[0].sp}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                  {hasZoneA && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          flexDirection: 'row',
                          flex: 1, // Занимает всю доступную высоту
                          alignItems: 'stretch',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            { width: '25%', backgroundColor: color('А') },
                          ]}
                        >
                          <Text style={styles.tableText}>
                            {zoneА[0].sector}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>
                            {formatWeight(zoneА[0].totalWeight)}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>
                            {noFishCaught ? data.length : zoneА[0].zonePlace}
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}

                  {hasZoneB && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          flexDirection: 'row',
                          flex: 1, // Занимает всю доступную высоту
                          alignItems: 'stretch',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            { width: '25%', backgroundColor: color('Б') },
                          ]}
                        >
                          <Text style={styles.tableText}>
                            {zoneБ[0].sector}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>
                            {formatWeight(zoneБ[0].totalWeight)}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>
                            {noFishCaught ? data.length : zoneБ[0].zonePlace}
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}

                  {hasZoneC && (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: groupWidth,
                          padding: 0,
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        },
                      ]}
                    >
                      <View
                        style={{
                          flexDirection: 'row',
                          flex: 1, // Занимает всю доступную высоту fill={color('В')}
                          alignItems: 'stretch',
                        }}
                      >
                        <View
                          style={[
                            styles.tableColHeader,
                            { width: '25%', backgroundColor: color('В') },
                          ]}
                        >
                          <Text style={styles.tableText}>
                            {zoneВ[0].sector}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '50%' }]}>
                          <Text style={styles.tableText}>
                            {formatWeight(zoneВ[0].totalWeight)}
                          </Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '25%' }]}>
                          <Text style={styles.tableText}>
                            {noFishCaught ? data.length : zoneВ[0].zonePlace}
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}

                  <View
                    style={[
                      styles.tableColHeader,
                      {
                        width: '15%',
                        padding: 0,
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      },
                    ]}
                  >
                    <View
                      style={{
                        flexDirection: 'row',
                        flex: 1, // Занимает всю доступную высоту
                        alignItems: 'stretch',
                      }}
                    >
                      <View style={[styles.tableColHeader, { width: '60%' }]}>
                        <Text style={styles.tableText}>
                          {formatWeight(item.totalGroupWeight) || 0}
                        </Text>
                      </View>
                      <View style={[styles.tableColHeader, { width: '40%' }]}>
                        <Text style={styles.tableText}>
                          {item.totalPlace || 0}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </>

            // <View
            //   key={index}
            //   style={{
            //     flexDirection: 'row',
            //     textAlign: 'center',
            //     borderBottomWidth: 0.5,
            //     borderBottomColor: '#000',
            //     backgroundColor,
            //   }}
            // >
            //   <View
            //     style={{ width: '5%', padding: 2, justifyContent: 'center' }}
            //   >
            //     {isfinish && item.finalPlace === 1 && (
            //       <Image src={Win1Icon} style={{ width: 13, height: 13 }} />
            //     )}
            //     {isfinish && item.finalPlace === 2 && (
            //       <Image src={Win2Icon} style={{ width: 13, height: 13 }} />
            //     )}
            //     {isfinish && item.finalPlace === 3 && (
            //       <Image src={Win3Icon} style={{ width: 13, height: 13 }} />
            //     )}
            //     {(!isfinish || item.finalPlace > 3) && (
            //       <Text style={{ fontSize: 8, fontWeight: 'bold' }}>
            //         {noFishCaught ? data.length : item.finalPlace}
            //       </Text>
            //     )}
            //   </View>

            //   <View style={{ width: '20%', textAlign: 'left', padding: 2 }}>
            //     <Text style={{ fontSize: 8 }}>{item.team || '-'}</Text>
            //   </View>

            //   <View style={{ width: '30%', flexDirection: 'row' }}>
            //     <View style={{ width: '60%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'left' }}>
            //         {zoneА[0].sp}
            //         {/* {zoneА
            //             .map((a) => a.strName)
            //             .filter(Boolean)
            //             .join(', ')} */}
            //       </Text>
            //     </View>
            //     <View style={{ width: '10%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {zoneА[0].sector}
            //       </Text>
            //     </View>
            //     <View style={{ width: '20%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {zoneА[0].totalWeight}
            //       </Text>
            //     </View>
            //     <View style={{ width: '10%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {noFishCaught ? data.length : zoneА[0].zonePlace}
            //       </Text>
            //     </View>
            //   </View>

            //   <View style={{ width: '30%', flexDirection: 'row' }}>
            //     <View style={{ width: '60%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'left' }}>
            //         {zoneБ[0].sp}
            //         {/* {zoneБ
            //           .map((a) => a.strName)
            //           .filter(Boolean)
            //           .join(', ')} */}
            //       </Text>
            //     </View>
            //     <View style={{ width: '10%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {zoneБ[0].sector}
            //       </Text>
            //     </View>
            //     <View style={{ width: '20%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {zoneБ[0].totalWeight}
            //       </Text>
            //     </View>
            //     <View style={{ width: '10%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {noFishCaught ? data.length : zoneБ[0].zonePlace}
            //       </Text>
            //     </View>
            //   </View>

            //   <View style={{ width: '15%', flexDirection: 'row' }}>
            //     <View style={{ width: '50%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {item.totalGroupWeight || 0}
            //       </Text>
            //     </View>
            //     <View style={{ width: '50%', padding: 2 }}>
            //       <Text style={{ fontSize: 8, textAlign: 'center' }}>
            //         {item.totalPlace || 0}
            //       </Text>
            //     </View>
            //   </View>
            // </View>
          )
        })}

        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
        </View>

        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default PairComandGroupTournamentProtocolPDF
